<template>
    <el-container class="h-100 position-relative">
        <sidenav
            v-if="hasWindowHeader && !$client.isMobile"
            :isVisible="isSidebarVisible"
            @menuClick="toggleSidebar(!isSidebarVisible)"
        ></sidenav>
        <!-- Yukarıdaki kısım enteresan bir biçimde pathler üzerindeki cliklerde de çalışıyor bundan dolayı  -->
        <!-- Bunun için mobilde her aktif buton ile sidebar açıyor. Sidebar yerine drawer koyduk çünkü -->
        <!-- Sidebar ile mobil çalıştırmak yukarıdaki belirtilen hatadan dolayı mümkün değil. -->
        <!-- TO DO: Yukarıdaki kısım yanlış çalışıyor genel bir durumda incelenmesi gerekiyor ve drawer ile devam edilebilir. @ali.soylemez -->
        <el-drawer :visible.sync="drawer" v-else size="100%" :withHeader="false" direction="ltr">
            <sidenav :isVisible="drawer" @menuClick="toggleDrawer(false)"></sidenav>
        </el-drawer>
        <i class="el-icon-close close-icon" v-if="drawer" @click="toggleDrawer(false)" />
        <el-container>
            <el-header height="70px" class="app-header" v-if="hasWindowHeader">
                <el-row type="flex" :justify="'flex-start'" class="h-100">
                    <div class="sidenav-toggle mr-10px">
                        <el-button
                            type="text"
                            size="mini"
                            class="p-5px toggle-btn"
                            @click="
                                $client.isMobile
                                    ? toggleDrawer(true)
                                    : toggleSidebar(!isSidebarVisible)
                            "
                        >
                            <i class="fa fa-bars"></i>
                        </el-button>
                    </div>
                    <div style="display: flex; justify-content: space-between" class="w-100">
                        <el-breadcrumb
                            separator-class="el-icon-arrow-right"
                            :class="!$client.isMobile ? 'pull-left' : null"
                        >
                            <el-breadcrumb-item
                                v-for="item in breadCrumbData"
                                :to="item.to"
                                :key="item.guid"
                                >{{ item.title }}</el-breadcrumb-item
                            >
                        </el-breadcrumb>
                        <a
                            v-if="hasHelpLink(breadCrumbData)"
                            target="_blank"
                            :href="
                                isAdmin
                                    ? breadCrumbData[breadCrumbData.length - 1].helpLink
                                    : breadCrumbData[breadCrumbData.length - 1].helpLinkEngineer
                            "
                        >
                            <i class="fa fa-lg fa-question-circle-o mt-10px"></i>
                        </a>
                    </div>
                </el-row>
            </el-header>
            <el-main class="position-relative">
                <!-- Inspection has been removed from cache due to rule parse initialization on section -->
                <keep-alive>
                    <router-view v-if="$route.meta.cache != false" :key="$route.name" />
                </keep-alive>
                <router-view v-if="$route.meta.cache == false" :key="$route.name" />
            </el-main>
            <el-footer class="app-footer text-align-right" v-if="hasWindowFooter">
                {{ $t('For an uninterrupted service, you must verify your email') }}
                <el-button
                    type="text"
                    class="p-0"
                    :loading="loading"
                    @click="onSendEmailVerification"
                    >{{ $t('Send Verification Email') }}
                </el-button>
            </el-footer>
        </el-container>
    </el-container>
</template>

<script>
import sidenav from '@/main/components/sidenav/index.vue';

export default {
    name: 'riskspace',
    components: { sidenav },
    data() {
        return {
            loading: false,
            isSidebarVisible: !this.$client.isMobile,
            drawer: false,
            nav: {
                fourofour: {
                    title: this.$t('Page Not Found'),
                },
                dashboard: {
                    title: this.$t('Dashboard'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-dashboard',
                },
                filemanager: {
                    title: this.$t('File Manager'),
                },
                customers: {
                    title: this.$t('Clients'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-clients-page',
                    helpLinkEngineer:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/clients-risk-engineer-account',
                },
                customerDetail: {
                    title: ($route) => {
                        if ($route.params && $route.params.customerId === 'new') {
                            return this.$t('New Client');
                        }

                        return this.$t('Client Detail');
                    },
                    helpLink: ($route) => {
                        if ($route.params && $route.params.customerId === 'new') {
                            return 'https://support.virtualriskspace.com/portal/en/kb/articles/adding-a-new-client';
                        }

                        return 'https://support.virtualriskspace.com/portal/en/kb/articles/editing-existing-clients-and-adding-policies';
                    },
                    parent: {
                        title: this.$t('Clients'),
                        to: '/clients',
                    },
                },
                microCustomers: {
                    title: this.$t(
                        this.$store.getters.isDamageNotice ? 'Clients' : 'Micro Clients'
                    ),
                },
                microCustomerDetail: {
                    // eslint-disable-next-line sonarjs/no-identical-functions
                    title: ($route) => {
                        if ($route.params && $route.params.customerId === 'new') {
                            return this.$t('New Client');
                        }

                        return this.$t('Client Detail');
                    },
                    parent: {
                        title: this.$t(
                            this.$store.getters.isDamageNotice ? 'Clients' : 'Micro Clients'
                        ),
                        to: '/micro-clients',
                    },
                },
                microList: {
                    title: this.$t(
                        this.$store.getters.isDamageNotice ? 'Client Lists' : 'Micro List'
                    ),
                },
                microListItemDetail: {
                    title: ($route) => {
                        if ($route.params && $route.params.itemId === 'new') {
                            return this.$t('New List');
                        }

                        return this.$t('Detail');
                    },
                    parent: {
                        title: this.$t(
                            this.$store.getters.isDamageNotice ? 'Client Lists' : 'Micro List'
                        ),
                        to: '/micro-list',
                    },
                },
                appointments: {
                    title: this.$t('Call Agenda'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/navigating-through-the-call-agenda',
                },
                conversations: {
                    title: this.$t('Call History'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-call-history-page',
                },
                conversationDetail: {
                    title: this.$t('Detail'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-call-details-page',
                    parent: {
                        title: this.$t('Call History'),
                        to: '/conversations',
                    },
                },
                representatives: {
                    title: this.$t('Risk Engineers'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-risk-engineers-page',
                    helpLinkEngineer:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/risk-engineers-risk-engineer-account',
                },
                representativeDetail: {
                    title: ($route) => {
                        if ($route.params && $route.params.id === 'new') {
                            return this.$t('New Engineer');
                        }

                        return this.$t('Engineer Detail');
                    },
                    helpLink: ($route) => {
                        if ($route.params && $route.params.id === 'new') {
                            return 'https://support.virtualriskspace.com/portal/en/kb/articles/adding-a-risk-engineer';
                        }

                        return 'https://support.virtualriskspace.com/portal/en/kb/articles/editing-a-risk-engineer';
                    },
                    parent: {
                        title: this.$t('Risk Engineers'),
                        to: '/representatives',
                    },
                },
                feeds: {
                    title: this.$t('Survey Management'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/overview-of-the-claim-and-survey-management-page',
                },
                organizations: {
                    title: this.$t('Organizations'),
                },
                users: {
                    title: this.$t('Organization Users'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/organization-users',
                },
                roles: {
                    title: this.$t('Role Management'),
                },
                forms: {
                    title: this.$t('Forms'),
                },
                form: {
                    title: this.$t('Questions'),
                    parent: {
                        title: this.$t('Forms'),
                        to: '/forms',
                    },
                },
                rules: {
                    title: this.$t('Rules'),
                    parent: {
                        title: this.$t('Forms'),
                        to: '/rules',
                    },
                },
                inspection: {
                    title: this.$t('Inspection Detail'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/accessing-and-filling-out-inspections',
                },
                videocall: {
                    title: this.$t('Video Call'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/how-to-start-a-call-from-the-set-call-tab',
                },
                meeting: {
                    title: this.$t('Set Meeting'),
                },
                reports: {
                    title: this.$t('Reports'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/the-portfolio-management-page',
                },
                auditlog: {
                    title: this.$t('Audit Log'),
                },
                adminreports: {
                    title: this.$t('Admin Reports'),
                    helpLink:
                        'https://support.virtualriskspace.com/portal/en/kb/articles/admin-reports-usage-data',
                },
                claimdashboard: {
                    title: this.$t('Dashboard'),
                },
                claimdetail: {
                    title: this.$t('Claim Detail'),
                },
                acknowledgement: {
                    title: this.$t('Acknowledgement Detail'),
                },
                claimdisplay: {
                    title: this.$t('Claim Display'),
                },
                sites: {
                    title: this.$t('Sites'),
                },
            },
        };
    },
    created() {
        this.$store.dispatch('fetchCurrentPosition');
    },
    computed: {
        isAdmin() {
            return this.$store.getters.context.isAdmin;
        },
        hasWindowHeader() {
            return window.hasWindowHeader !== false ? true : window.hasWindowHeader;
        },
        hasWindowFooter() {
            return !this.$store.getters.user.email_verified;
        },
        language() {
            const language = navigator.language || navigator.userLanguage;
            return language.indexOf('tr') > -1 ? 'TR' : 'EN';
        },
        breadCrumbData() {
            const route = this.$route;
            const routeName = route.name;
            const navItem = this.nav[routeName];
            const data = [];
            const hasParent = navItem && navItem.parent;

            let title = '';
            let helpLink = '';
            let helpLinkEngineer = '';

            if (navItem) {
                title = typeof navItem.title === 'function' ? navItem.title(route) : navItem.title;
                helpLink =
                    typeof navItem.helpLink == 'function'
                        ? navItem.helpLink(route)
                        : navItem.helpLink;
                helpLinkEngineer =
                    typeof navItem.helpLinkEngineer == 'function'
                        ? navItem.helpLinkEngineer(route)
                        : navItem.helpLinkEngineer;
            }

            if (hasParent) {
                data.push({
                    title: navItem.parent.title,
                    to: navItem.parent.to,
                });
            }
            data.push({
                title,
                helpLink,
                helpLinkEngineer,
            });

            return data;
        },
    },
    methods: {
        hasHelpLink(data) {
            return this.isAdmin
                ? data[data.length - 1].helpLink
                : data[data.length - 1].helpLinkEngineer;
        },
        toggleSidebar(flag) {
            this.isSidebarVisible = flag;
        },
        toggleDrawer(v) {
            this.drawer = v;
        },
        onSendEmailVerification() {
            this.$store.getters.context.verifyEmail({
                beforesend: () => {
                    this.loading = true;
                },
                complete: () => {
                    this.loading = false;
                },
                success: () => {
                    this.$store.getters.user.email_verified = true;
                },
                failure: (err, response) => {
                    if (err instanceof Error) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: err.message,
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: response.meta.display_message,
                        });
                    }
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/responsive.scss';
.el-main {
    @include sm {
        // el-main sınıfıyla gelen 20px'i paddingi mobil için daha fazla yer açmak için ez
        padding: 4px;
        max-width: 100%;
    }
}

.el-aside {
    @include sm {
        width: 100% !important;
    }
}

.close-icon {
    position: absolute;
    font-size: 1.5rem;
    right: 5px;
    top: 5px;
    z-index: 9999;
    color: white;
}
.el-footer {
    font-size: 12px;
    height: 40px !important;
    display: none;

    button {
        font-size: 12px;
    }

    @media (min-width: 768px) {
        font-size: 14px;
        height: 30px !important;
        display: block;

        button {
            font-size: 14px;
        }
    }
}
</style>
